export const htmlToText = (htmlString: string) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = htmlString;

    const decodedHtml = textarea.value;
    const helperSpan = document.createElement('span');
    helperSpan.innerHTML = decodedHtml;

    return helperSpan.innerText;
};
